export const SortIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none" style={{ marginLeft: '6px' }}>
    <path d="M12.6287 10.9021L8.99344 16.3143L5.41235 10.9021H12.6287Z" fill="#40444D" />
    <path d="M9.0205 3.68579L5.41235 9.09801H12.6287L9.0205 3.68579Z" fill="#40444D" />
  </svg>
);
